import {Component, OnInit, ViewChild} from '@angular/core';
import {User} from '../../Interfaces/User';
import {Subscription} from 'rxjs';
import {ClientRequest} from '../../Interfaces/ClientRequest';
import {UntypedFormBuilder, UntypedFormGroup} from '@angular/forms';
import {Router} from '@angular/router';
import {QueryService} from '../../Services/query.service';
import {AppComponent} from '../../app.component';
import {GlobalEventsManager} from '../../GlobalEventManager';
import {EmailReport} from '../../Interfaces/EmailReport';
import {MatTableDataSource} from '@angular/material/table';
import {MatSort} from '@angular/material/sort';
import {MatPaginator} from '@angular/material/paginator';

@Component({
  selector: 'app-email-reports',
  templateUrl: './email-reports.component.html',
  styleUrls: ['./email-reports.component.css']
})
export class EmailReportsComponent implements OnInit {
  public  myUser: User;
  emailReportData: MatTableDataSource<EmailReport>;
  emailReportArray: EmailReport[];
  public cColumns: string[];
  public containerNum: string;
  subscription: Subscription;
  subscription2: Subscription;
  private clientRequest: ClientRequest;
  noContFound: boolean = false;
  showScreen: boolean = true;
  phoneApp: boolean = false;
  public formatsArray : {code:string, description:string}[] = [];
  myForm: UntypedFormGroup;
  @ViewChild(MatSort) set content(sort: MatSort) {
    if (this.emailReportData != undefined) {
      this.emailReportData.sort = sort;
    }
  }

  @ViewChild(MatPaginator) set content2(pag: MatPaginator) {
    if (this.emailReportData != undefined) {
      this.emailReportData.paginator = pag;
    }
  }

  get f() { return this.myForm.controls;}

  constructor(fb: UntypedFormBuilder,  private router: Router, private  queryService: QueryService, public myApp:AppComponent,private  globalEventsManager: GlobalEventsManager) {
    this.cColumns = ["report","email", "format"];


    this.myUser = this.myApp.user;
/*
                this.myUser = {} as User;
                this.myUser.active ="Y"
                this.myUser.address_1 = "15600 JFK BLVD. Suite 400"
                this.myUser.address_2 = null
                this.myUser.company_code ="O7600"
                this.myUser.company_name= "MAHER TERMINALS, LLC"
                this.myUser.city= "HOUSTON"
                this.myUser.email_address= null
                this.myUser.fax_number= null
                this.myUser.first_name= "Csp Craig"
                this.myUser.last_name= "Miller"
                this.myUser. maherError= null
                this.myUser.old_password= null
                this.myUser.password= ""
                this.myUser.phone_number= null
                this.myUser.company_scac= null
                this.myUser.state= "TX"
                this.myUser.userMenuReportItemsView= null
                this.myUser.user_gkey= "8237887"
                this.myUser.role= "AGENT"
              //  this.myUser.role= "HAULIER"
                this.myUser.username="CDOUG"
                this.myUser.zip="07201"
                this.myUser.canSeeAllData = "0";


*/




  }

  ngOnInit() {
    this.showScreen = true;
    this.formatsArray = [];
    this.formatsArray.push({"code": "P", "description": "PDF"});
    this.formatsArray.push({"code": "E", "description": "Excel"});


    this.getReportEmailsAddressByAccount();

    if (window.innerWidth <= 800){
      this.phoneApp = true;
    }


  }

  private getReportEmailsAddressByAccount(){
    this.clientRequest = null;
    this.clientRequest = {} as ClientRequest;
    this.clientRequest.user = this.myUser;
    this.clientRequest.requestData = [];
    const lhsUserObs$ = this.queryService.getReportEmailsAddressByAccount(this.clientRequest);
    this.subscription = lhsUserObs$.subscribe(
      (cus) => {
        this.emailReportArray = cus;
      },
      error => {
        if (error.status == "401") {
          this.globalEventsManager.showLogin.emit(true);
          this.router.navigate(["login"]);
        } else {
          this.myApp.openDialog(error.message)
        }
      },
      () => {

        for (var item of this.emailReportArray){
          if (item.attachment_type_code==null || item.attachment_type_code==" "){
            item.attachment_type_code = this.formatsArray[0].code;
          }

          if (item.maherError!=null && item.maherError!=""){
            if (item.email_address!=null){
                  this.validEmail(item);
            }

          }
        }
        this.emailReportData = new MatTableDataSource<EmailReport>(this.emailReportArray);
      });
  }



  validEmail(rowIn: EmailReport){
    var format = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{1,}$/;
    if(format.test(rowIn.email_address)){
      rowIn.invalidEmail = false;
    }else{
      rowIn.invalidEmail = true;
    }

  }

  private insertUpdateEmailReportAddress(fromWhere: string, rowIn: EmailReport) {


    if (!rowIn.invalidEmail) {
      if (fromWhere == "D") {
        rowIn.active = "0";
      }
      this.emailReportArray = [];
      this.emailReportArray.push(rowIn);

      this.clientRequest = null;
      this.clientRequest = {} as ClientRequest;
      this.clientRequest.user = this.myUser;
      this.clientRequest.requestData = this.emailReportArray;
      const lhsUserObs$ = this.queryService.insertUpdateEmailReportAddress(this.clientRequest);
      this.subscription = lhsUserObs$.subscribe(
        (cus) => {
          this.emailReportArray = cus;
        },
        error => {
          if (error.status == "401") {
            this.globalEventsManager.showLogin.emit(true);
            this.router.navigate(["login"]);
          } else {
            this.myApp.openDialog(error.message)
          }
        },
        () => {
          this.getReportEmailsAddressByAccount();
          this.myApp.showSuccessBanner("", "the new email has been saved successfully", "emailreports");


        });
    }
  }



  leaveScreen(){
    this.showScreen = false;
    this.subscription2.unsubscribe();
    this.myApp.showCharts();
  }





}
